// China build only (CHINA-0): fixed native name + helper per language — static, not i18n.
export const CHINA_LANGUAGE_LABELS: Record<string, { name: string; helper: string }> = {
  zh: { name: "简体中文", helper: "Simplified Chinese" },
  "zh-tw": { name: "繁體中文（台灣）", helper: "Traditional Chinese · Taiwan" },
  "zh-hk": { name: "繁體中文（香港）", helper: "Traditional Chinese · Hong Kong" },
  en: { name: "English", helper: "英语" },
  fr: { name: "Français", helper: "French · 法语" },
  es: { name: "Español", helper: "Spanish · 西班牙语" },
  de: { name: "Deutsch", helper: "German · 德语" },
  vi: { name: "Tiếng Việt", helper: "Vietnamese · 越南语" },
  th: { name: "ไทย", helper: "Thai · 泰语" },
  tr: { name: "Türkçe", helper: "Turkish · 土耳其语" },
};

export const renderChinaLanguageLabel = (code: string, styles: Record<string, string>) => {
  const label = CHINA_LANGUAGE_LABELS[code];
  if (!label) return null;
  return (
    <span className={styles.chinaLabel}>
      <span lang={code} className={styles.chinaName}>
        {label.name}
      </span>
      <span className={styles.chinaHelper}>{label.helper}</span>
    </span>
  );
};
